var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icon-hotel-card"},[_c('icon-base',{attrs:{"width":16,"height":16}},[_c(_vm.componentIcon,{tag:"component"})],1),_vm._v(" "),_c('div',{staticClass:"icon-hotel-card__text"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }